import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCountryList,
  viewStateList,
} from "../../Redux/Actions/settingsActions";
import { columnsState } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";

const ListState = () => {
  const { id } = useParams();

  const STALE_TIME = process.env.REACT_APP_STALE_TIME;

  const dispatch = useDispatch();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [querySearch, setQuerySearch] = useState([]);

  const { loading, states, lastFetched } = useSelector((state) => state.states);
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');


  const fetchDetails = (page, limit, id) => {
    const countryData = {
      page,
      limit,
    };
    const stateData = {
      page,
      limit,
      country: id,
    };

    const isStale = !lastFetched || Date.now() - lastFetched > STALE_TIME;
    dispatch(viewCountryList(countryData));
    if (id) {
      dispatch(viewStateList(stateData));
      if (isStale) {
      }
    }
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize, id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (states?.total) {
      setPagination((prevData) => ({ ...prevData, total: states.total }));
    }
  }, [states]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize, id);
  };

  const filteredStates = useMemo(
    () =>
      Array.isArray(states?.data)
        ? states.data.filter((state) =>
          state.state_name?.toLowerCase().includes(querySearch)
        )
        : [],
    [states, querySearch]
  );

  const columns = useMemo(() => columnsState(canEdit), [canEdit]);

  return (
    <TableComponent
      h3heading="State List"
      buttonhead2={canAdd ? "Add State" : null}
      navigateTo2={canAdd ? `/state/add/${id}` : null}
      buttonhead="Go Back"
      navigateTo={`/country`}
      setState={setQuerySearch}
      columns={columns}
      rowKey="_id"
      dataSource={filteredStates}
      pagination={pagination}
      loading={loading}
      onChange={handleTableChange}
    ></TableComponent>
  );
};

export default ListState;
